<template>
    <div id="app_pc">
    <the-header></the-header>
    <the-nav></the-nav>
    <main>
        <div class="mainContents">
            <popup-posts/>
            <!-- <component :is="activePage"></component> -->
            <section class="part_contents">
                <router-view/>
                <!-- <post-recent/>-->
                <div class="banner_wrapper main_bottom">
                    <div class="bottom_banner">
                        <!-- <banner-ad :rect_width="890" :rect_height="100" filename='banner03.jpg'/> -->
                        <banner-slide slide_width="890px" slide_height="100px" banner_pos="banner5" :slide_delay="20000" />
                    </div>
                   
                </div>
            </section>
            <section class="part_side">              
                <div class="post_ranking">
                    <post-rank/>
                </div>
                <div class="banner_wrapper">
                    <!-- <a href="http://joyngame.co.kr" target="_blank"><banner-ad :rect_height="100" filename='banner02.jpg'/></a> -->
                    <banner-slide slide_width="400px" slide_height="100px" banner_pos="banner2" :slide_delay="20000"/>
                </div>
                <div class="banner_wrapper">
                   <banner-slide slide_width="400px" slide_height="100px" banner_pos="banner3" :slide_delay="30000" />
                </div>
               
                 <div class="banner_wrapper">
                   <banner-slide slide_width="400px" slide_height="100px" banner_pos="banner4" :slide_delay="25000" />
                </div>

                <div class="wrapper-chat">
                    <chat-base chat_roomId='m1' :headerdisplay='true' :viewList="true"></chat-base>
                </div>

                <div class="user_ranking">
                    <user-rank/>
                </div>
               
               
                <div class="infoarea">
                    <span>불법도박 사이트 근절 캠페인</span>
                    <p>
                        사이버머니, 현금 또는 아이템 등을 걸고 스포츠 경기 결과예측 및 
                        유사게임 행위를 비롯해 체육 진흥투표권 사업과 관련한 각종 
                        부정행위를 목격한 사람은 클린스포츠 통합콜센터(1899-1119)를
                        통해 신고 할 수 있습니다.
                    </p>                        
                </div>
            </section>

        </div>
    </main>
    <the-footer/>
    </div>
</template>

<script>
import TheHeader from '@/components/site/main/TheHeader.vue';
import TheNav from '@/components/site/main/TheNavigation.vue';
import ChatBase from '@/components/chat/ChatBase.vue';
import TheFooter from '@/components/site/TheFooter';
//import BannerAd from '@/components/site/BannerAD';
import BannerSlide from '@/components/banner/BannerSlide';
import UserRank from '@/components/users/PointRankingWidget';
import PostRank from '@/components/posts/PostRankingWidget';
import PopupPosts from '@/components/posts/PostPopup';
export default {   
    components: {
        TheHeader,
        TheNav,
        ChatBase,
        //PostRecent,
        TheFooter,
        //BannerAd,
        BannerSlide,
        UserRank,
        PopupPosts,
        PostRank
    },
    data:function(){
        return {
            currentUser:null,
            testUser:null

        }
    },
    created:function(){
        this.currentUser = this.$store.getters.currentUser;
        this.testUser = this.$store.getters.testUser;
        //console.log('나와라 좀!'+  this.currentUser.nic);
        //console.log('둘중하나!'+  this.testUser.nic);
    },
    computed:{
        isLoggedIn:function() {
            return this.$store.getters.isAuthenticated;
        },
        user:function(){
            return this.$store.getters.currentUser;
        }
    }
}
</script>

<style lang="scss" scoped>
#app_pc{
    background:#f2f4f7;
    min-width:1300px;
}
/* 칼라 정의 */
.mainContents{
    
    .banner_wrapper{
        margin-top:10px;
    }
    .main_bottom{
        display: flex;
        .bottom_banner{
            display: flex;
            align-items:flex-end;
        }
        
    }
    .user_ranking{
        margin-top:10px;
    }
    .wrapper-chat{
        margin-top:10px;   
    }
    .infoarea{
        background:rgb(12, 6, 46);
        margin-top:10px;
        font-family: '나눔고딕';            
        padding:16px 14px 14px 14px;
        width: 100%;        
        border: 1px solid #ccc;
        color:#fff;
        span{
            font-weight: bold;
            font-size:14px;
            color:rgb(231, 95, 95);    
        }
        p{
            white-space:pre-line;  
            line-height: 1.5em;  
        }
    }
}

</style>
